import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { OrderWithContext, BagPickupLocation, FormField, Restaurant } from '@/models';

interface PickupOption {
  name: string;
  bagPickupLocationId: BagPickupLocation;
  videoUrl?: string;
  imageUrl?: string;
}

@Component({
  name: 'CmgCheckoutOrderPickupOptions',
})
export default class CmgCheckoutOrderPickupOptions extends Vue {
  pickupOptions: PickupOption[] = [
    {
      name: 'Chipotlane',
      bagPickupLocationId: BagPickupLocation.Chipotlane,
      videoUrl: this.$appStore.state.cms.animations.checkout.chipotlane
    },
    {
      name: 'Walk-Up Window',
      bagPickupLocationId: BagPickupLocation.WalkUpWindow,
      imageUrl: this.$appStore.state.cms.images.walkUpWindow.default,
    },
    {
      name: 'Pickup Inside',
      bagPickupLocationId: BagPickupLocation.Shelf,
      videoUrl: this.$appStore.state.cms.animations.checkout.shelfPickup
    }
  ];

  bagPickupLocation: BagPickupLocation | null = null;
  pickupOptionImageUrl = '';

  get videoLabel(): string {
    return this.bagPickupLocation == BagPickupLocation.Chipotlane ? 'Pickup at the window' : 'On the shelf';
  }

  get restaurant(): Restaurant | null {
    return this.$appStore.state.restaurant.selectedRestaurant;
  }

  get filteredPickupOptions(): PickupOption[] {  
    return this.pickupOptions.filter(option => {
      return (this.restaurant?.walkupWindowEnabled && option.bagPickupLocationId == BagPickupLocation.WalkUpWindow) || 
             (this.restaurant?.chipotlanePickupEnabled && option.bagPickupLocationId == BagPickupLocation.Chipotlane) ||
             (this.restaurant?.pickupInsideEnabled && option.bagPickupLocationId == BagPickupLocation.Shelf);
    });
  }

  get order(): OrderWithContext | null {
    return this.$services.order.getCurrentOrder();
  }

  get selectedPickupRestaurant() {
    return this.$appStore.state.restaurant.selectedRestaurant;
  }

  get isOrderCompleted(): boolean {
    return !!this.order && this.order.order.isOrderComplete;
  }

  get isChipotlaneSelected(): boolean {
    return this.bagPickupLocation == BagPickupLocation.Chipotlane;
  }

  @Watch('restaurant', { immediate: false, deep: true })
  onRestaurantLocationChanged(newRestaurants: Restaurant[]) {
    this.setBagPickupLocation(this.restaurant?.chipotlanePickupEnabled ? BagPickupLocation.Chipotlane : this.restaurant?.walkupWindowEnabled ? BagPickupLocation.WalkUpWindow : BagPickupLocation.Shelf);
  }

  mounted() {
    this.setBagPickupLocation(this.restaurant?.chipotlanePickupEnabled ? BagPickupLocation.Chipotlane : this.restaurant?.walkupWindowEnabled ? BagPickupLocation.WalkUpWindow : BagPickupLocation.Shelf)
  }

  getVideoUrl(): string {
    const pickupOption = this.pickupOptions.find(option => option.bagPickupLocationId == this.bagPickupLocation);
    return pickupOption?.videoUrl ?? '';
  }

  setBagPickupLocation(bagLocationId: BagPickupLocation) {
    const pickupOption = this.pickupOptions.find(option => option.bagPickupLocationId == bagLocationId);
    this.pickupOptionImageUrl = pickupOption?.videoUrl ?? pickupOption?.imageUrl ?? '';
    this.bagPickupLocation = bagLocationId;
    this.$emit('set-bag-pickup-location', this.bagPickupLocation);
  }

  onSelectPickupOption(bagLocationId: BagPickupLocation) {
    this.setBagPickupLocation(bagLocationId);
  }
}
